import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ProductsService } from 'src/app/services/products.service';

@Component({
	selector: 'app-warehouse',
	template: `
		<div class="position-relative d-flex justify-content-center">
			<div class="headline-filter-0">{{text}}</div>
			<div class="mini-filter">
				<ng-select [items]="items?.data" [(ngModel)]="selectedId" (ngModelChange)="selectedIdChange.emit(selectedId)" bindLabel="name" bindValue="code"
				[clearable]="false">
					<ng-template ng-label-tmp let-item="item">
						{{ item?.name | titlecase }}
					</ng-template>
				</ng-select>
			</div>
		</div>
	`
})
export class AppWarehouseComponent implements OnInit {
	@Input() text = 'Warehouse Name';
	@Input() selectedId: string;
	@Output() selectedIdChange = new EventEmitter();
	items = {
		data: [],
		limit: 100,
		total: 0,
	}

	constructor(private _productService: ProductsService,) { }

	ngOnInit() {
		this.getData();
	}

	getData() {
		if (this.items.data.length && this.items.data.length >= this.items.total) return;
		this._productService.warehouseFilter(this.items.limit, this.items.data.length).subscribe((res: any) => {
			const mappedData = (res.data || []).map(d => {
				return {
					code: d.code,
					id: d.id,
					name: d.name,
				}
			});
			this.items.data = [...this.items.data, ...mappedData];
			this.items.total = res.metadata.total;
			if (this.items.data.length) {
				if (this.items.data.length < this.items.total) this.getData();
				else this.items.data.unshift({
					code: '',
					id: 0,
					name: 'All',
				});
			}
		});
	}
}
